import { combineReducers } from 'redux';

import AppState from '../modules/App/AppState';
import ProductState from '../modules/Product/ProductState';
import TimingState from '../../../core_components/TimingHandler/TimingState';

export default combineReducers({
  AppState,
  ProductState,
  TimingState,
});



/** WEBPACK FOOTER **
 ** ./apps/maptool/redux/reducer.js
 **/